import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import moment from 'moment';
import _ from 'lodash';
import * as actions from './redux/actions';
import {Link} from "react-router-dom";

export class DefaultPage extends Component {
  static propTypes = {
    access: PropTypes.object.isRequired,
    customers: PropTypes.array.isRequired,
    actions: PropTypes.object.isRequired,
  };

  render() {
    const { customers } = this.props;
    return (
      <div className="content-animate">
        <h1>Lizenzen</h1>
        <div className="row">
          <table className="table table-striped">
            <thead>
            <tr>
              <td>Name</td>
              <td>Produkt</td>
              <td>Lizenzdauer</td>
              <td>Lizenz</td>
              <td>Lizenz gültig bis</td>
            </tr>
            </thead>
            <tbody>
            {customers && _.sortBy(customers, ['status']).reverse().map(license => (
                <tr key={JSON.stringify(license)}>
                  <td><Link to={`products/${license.product_id}/${license.user_id}`} >{license.first_name} {license.last_name}</Link></td>
                  <td>{license.name}</td>
                  <td>{license.activated && `${license.activated} Monate`}</td>
                  <td className={license.status === '1' ? 'bg-success text-white' : 'bg-danger text-white'}>{moment().isBefore(moment(license.expires)) ? 'Aktiviert' : 'Deaktiviert'}</td>
                  <td>{license.expires}</td>
                </tr>
            ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    access: state.access,
    customers: state.home.customers,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DefaultPage);



// WEBPACK FOOTER //
// ./src/features/access/DefaultPage.js